module.exports = __webpack_public_path__ + "img/instagramestory2.a16e1e82.jpg";